import { useQuery } from 'react-query';
import { fetchCommunityGlobalStats } from 'react-scale/components/ExpertManagement/ExpertManagementPage/api';

export const useFetchCommunityGlobalStats = () => {
  return useQuery(['communityGlobalStats'], () => fetchCommunityGlobalStats(), {
    staleTime: 60 * 60 * 1000,
  });
};
